import CommerceOnly from '/src/_includes/commerce-only.md';
import B2BRoles from '/src/_includes/graphql/b2b-roles.md';
import * as React from 'react';
export default {
  CommerceOnly,
  B2BRoles,
  React
};